import { css } from '@emotion/react';
import type { ComponentProps } from 'react';

export const FormText = (props: ComponentProps<'div'>) => {
  return (
    <div
      css={css`
        --ant-input-padding-block: 4px;
        --ant-input-padding-block-sm: 0px;
        --ant-input-padding-block-lg: 7px;
        --ant-input-padding-inline: 11px;
        --ant-input-padding-inline-sm: 7px;
        --ant-input-padding-inline-lg: 11px;
        --ant-input-addon-bg: rgba(255, 255, 255, 0.04);
        --ant-input-active-border-color: #1668dc;
        --ant-input-hover-border-color: #3c89e8;
        --ant-input-active-shadow: 0 0 0 2px rgba(23, 117, 249, 0.31);
        --ant-input-error-active-shadow: 0 0 0 2px rgba(238, 38, 56, 0.11);
        --ant-input-warning-active-shadow: 0 0 0 2px rgba(173, 107, 0, 0.15);
        --ant-input-hover-bg: #141414;
        --ant-input-active-bg: #141414;
        --ant-input-input-font-size: 14px;
        --ant-input-input-font-size-lg: 16px;
        --ant-input-input-font-size-sm: 14px;

        cursor: text;
        text-align: justify;

        box-sizing: border-box;
        margin: 0;
        padding: var(--ant-input-padding-block) var(--ant-input-padding-inline);
        color: var(--ant-color-text);
        font-size: var(--ant-input-input-font-size);
        line-height: var(--ant-line-height);
        list-style: none;
        font-family: var(--ant-font-family);
        position: relative;
        display: inline-block;
        width: 100%;
        min-width: 0;
        border-radius: var(--ant-border-radius);
        transition: all var(--ant-motion-duration-mid);

        background: var(--ant-color-bg-container);
        border-width: var(--ant-line-width);
        border-style: var(--ant-line-type);
        border-color: var(--ant-color-border);

        max-width: 100%;
        height: auto;
        min-height: var(--ant-control-height);
        line-height: var(--ant-line-height);
        vertical-align: bottom;
        transition: all var(--ant-motion-duration-slow);
        resize: vertical;
      `}
      {...props}
    ></div>
  );
};
